export const safeTestId = (testId?: string, postfix?: string) => {
  if (testId) {
    return `${testId}-${postfix}`
  }

  return undefined
}
